import { Cirus } from "@/classes/Http";
import "reflect-metadata";
import { Type } from "class-transformer";
import { IsArray, IsNumber, IsOptional, IsString, IsUUID, Min, validate, ValidateNested } from "class-validator";
import { Message } from "element-ui";
import { v4 } from 'uuid'

const errorMessages: any = {
    prices: 'لطفا قیمت ها را اصلاح کنید',
    filter_id: 'آیدی فیلتر معتبر نمی باشد. لطفا دوباره تلاش کنید.',
    limit: 'لیمیت تعیین شده نا معتبر می باشد.',
    option_id: 'مورد انتخاب شده نا معتبر می باشد.',
}

class Price  {
    constructor(price: Price) {
        this.id = price.id || v4();
        this.name = price.name;
        this.price = price.price;
        this.price_with_off = price.price_with_off;
        this.limit = price.limit;
        this.option_id = price.option_id;
    }
    @IsUUID()
    @IsOptional()
    id: string = null;

    @IsString()
    name: string;

    @IsNumber()
    @Min(0)
    @IsOptional()
    price = 0;

    @IsNumber()
    @Min(0)
    @IsOptional()
    price_with_off: number = null;

    @IsNumber()
    @Min(0)
    @IsOptional()
    limit: number;

    @IsUUID()
    option_id: string;
}

export class SetInstanceProductPriceFilterRequest {
    constructor(params: SetInstanceProductPriceFilterRequest) {
        this.filter_id = params.filter_id;
        this.prices = params.prices.map(p=>new Price(p));
    }
    @IsUUID()
    filter_id: string;

    @IsArray()
    @Type(() => Price)
    @ValidateNested()
    prices: Price[];
}

export async function setProductPriceFilter(instance_id: number, product_id: string, params : SetInstanceProductPriceFilterRequest) {
    params = new SetInstanceProductPriceFilterRequest(params);
    const errors = await validate(params);
    if (errors.length>0)  {
        console.log(errors);
        Message.error(errorMessages[errors[0].property])
        throw new Error("اطلاعات وارد شده صحیح نمی ‌باشد.");
    }
    const path = `/instance/${instance_id}/product/${product_id}/price-filter`;
    return Cirus.post(path, params);
}